import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import { GetSampleLocations } from "../../../services/ClientsMaintenanceService";

const SampleLocationsDialog = ({ open, onClose, accountNumber }) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && accountNumber) {
      loadLocations();
    }
  }, [open, accountNumber]);

  const loadLocations = async () => {
    try {
      setLoading(true);
      const res = await GetSampleLocations(accountNumber);
      setLocations(res.results || []);
    } catch {
      setLocations([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Sample Locations — Account {accountNumber}</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : locations.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 2 }}>
            No sample locations found for this account.
          </Typography>
        ) : (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>Location</strong></TableCell>
                  <TableCell><strong>Sampling Point</strong></TableCell>
                  <TableCell><strong>Description</strong></TableCell>
                  <TableCell><strong>Type</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {locations.map((row) => (
                  <TableRow key={row.recordid} hover>
                    <TableCell>{row.location}</TableCell>
                    <TableCell>{row.samppoint}</TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>{row.sptype}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SampleLocationsDialog;
